import AppLoading from './AppLoading';

export { AppLoadingProps } from './AppLoading.types';

export default AppLoading;
